import { useMutation } from '@tanstack/react-query';
import { type SupportedLocale } from '@zep-us/i18n';

import { youtubeApi } from '@/api/ai/youtube';

export const useFetchSubtitle = () => {
  return useMutation({
    mutationFn: ({
      videoId,
      locale,
    }: {
      videoId: string;
      locale: SupportedLocale;
    }) => youtubeApi.fetchSubtitle(videoId, locale),
  });
};
